module.exports = __webpack_public_path__ + "static/media/myr.static.48cd50cf.svg";